import { render, staticRenderFns } from "./UserContactsTable.vue?vue&type=template&id=8f5736e2&"
import script from "./UserContactsTable.vue?vue&type=script&lang=ts&"
export * from "./UserContactsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports